import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { braspressLogo } from '../assets/braspress-logo';

export const contentDeclaration = ({
  senderData,
  recipientData,
  commodityList
}) => {
  const formatNumber = (n) => {
    // format number 1234567 to 1.234.567
    return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const formatCurrency = ({ value }) => {
    // check for decimal
    if (value.indexOf(',') >= 0) {
      // get position of first decimal
      // this prevents multiple decimals from
      // being entered
      const decimal_pos = value.indexOf(',');

      // split number by decimal point
      let left_side = value.substring(0, decimal_pos);
      let right_side = value.substring(decimal_pos);

      // add commas to left side of number
      left_side = formatNumber(left_side);

      // validate right side
      right_side = formatNumber(right_side);

      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 2);

      // join number by ,
      value = `${left_side},${right_side}`;
    } else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      value = formatNumber(value);
      value = `${value}`;

      value += ',00';
    }

    return value;
  };

  const commodityBody = [
    [{ colSpan: 6, text: 'Mercadorias' }, '', '', '', '', ''],
    [
      'Descrição dos Bens',
      'Quantidade',
      'Peso',
      'Valor Unitário',
      'Valor Total',
      'Observações'
    ]
  ];

  commodityList.forEach((commodity) => {
    commodityBody.push([
      commodity.description,
      commodity.quantity,
      commodity.weight,
      commodity.unityValue,
      commodity.totalValue,
      commodity.observation
    ]);
  });

  if (commodityList.length > 1) {
    let total = commodityList.reduce(
      (accumulator, current) =>
        accumulator +
        parseFloat(current.totalValue.replaceAll('.', '').replace(',', '.')),
      0
    );

    total = total.toFixed(2).replace('.', ',');

    total = formatCurrency({ value: total });

    commodityBody.push([
      {
        colSpan: 6,
        text: 'Total Geral',
        style: {
          alignment: 'right'
        }
      },
      '',
      '',
      '',
      '',
      ''
    ]);
    commodityBody.push([
      {
        colSpan: 6,
        text: total,
        style: {
          alignment: 'right'
        }
      },
      '',
      '',
      '',
      '',
      ''
    ]);
  }

  const locale = senderData.address.city
    .split(' ')
    .map((value) =>
      value.length > 2
        ? value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)
        : value.toLowerCase()
    )
    .join(' ');

  const date = format(new Date(), "dd 'de' MMMM 'de' yyyy", { locale: ptBR });

  const dateSplitted = date.split(' ');

  const month = dateSplitted[dateSplitted.length - 3];

  dateSplitted[dateSplitted.length - 3] =
    month.charAt(0).toUpperCase() + month.slice(1);

  const dateParsed = dateSplitted.join(' ');

  return {
    content: [
      {
        table: {
          widths: [515],
          body: [
            [
              {
                text: 'FORMULÁRIO DE DECLARAÇÃO DE CONTEÚDO DE MERCADORIA'
              }
            ],
            [
              {
                image: braspressLogo.blue,
                width: 200,
                margin: [0, 10, 0, 10]
              }
            ],
            [
              {
                text: 'Declaro, para os devidos fins de direito que as mercadorias relacionadas nesta declaração e entregues a transporte para a BRASPRESS TRANSPORTES URGENTES LTDA. estão legalmente dispensadas da emissão de nota fiscal por se enquadrarem em alguma(s) das condições a seguir:\r\n*Pessoa física e empresas não contribuintes, que por lei estão dispensadas de emissão de Nota Fiscal.\r\nEstou ciente que a inexatidão das informações prestadas poderá ensejar penalizações e multas de minha responsabilidade.',
                style: {
                  alignment: 'justify'
                }
              }
            ],
            [
              {
                margin: [0, 10, 0, 0],
                table: {
                  widths: [76, 67, 51, 70, 40, 65, 43, 30],
                  body: [
                    [
                      {
                        colSpan: 8,
                        text: 'Remetente'
                      },
                      '',
                      '',
                      '',
                      '',
                      '',
                      '',
                      ''
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'CNPJ'
                      },
                      {
                        colSpan: 7,
                        text: senderData?.document
                      },
                      '',
                      '',
                      '',
                      '',
                      '',
                      ''
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'Nome/Razão Social'
                      },
                      {
                        colSpan: 7,
                        text: senderData?.name
                      }
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'CEP'
                      },
                      {
                        colSpan: 1,
                        text: senderData?.address?.zipPostalCode
                      },
                      {
                        colSpan: 1,
                        text: 'Endereço'
                      },
                      {
                        colSpan: 3,
                        text: senderData?.address?.streetAddress
                      },
                      '',
                      '',
                      {
                        colSpan: 1,
                        text: 'Número'
                      },
                      {
                        colSpan: 1,
                        text: senderData?.address?.streetAddressNumber
                      }
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'Complemento'
                      },
                      {
                        colSpan: 1,
                        text: senderData?.address?.additionalInformation
                      },
                      {
                        colSpan: 1,
                        text: 'Bairro'
                      },
                      {
                        colSpan: 1,
                        text: senderData?.address?.suburb
                      },
                      {
                        colSpan: 1,
                        text: 'Cidade'
                      },
                      {
                        colSpan: 1,
                        text: senderData?.address?.city
                      },
                      {
                        colSpan: 1,
                        text: 'Estado'
                      },
                      {
                        colSpan: 1,
                        text: senderData?.address?.state
                      }
                    ]
                  ]
                }
              }
            ],
            [
              {
                margin: [0, 10, 0, 0],
                table: {
                  widths: [76, 67, 51, 70, 40, 65, 43, 30],
                  body: [
                    [
                      {
                        colSpan: 8,
                        text: 'Destinatário'
                      },
                      '',
                      '',
                      '',
                      '',
                      '',
                      '',
                      ''
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'CNPJ'
                      },
                      {
                        colSpan: 7,
                        text: recipientData?.document
                      },
                      '',
                      '',
                      '',
                      '',
                      '',
                      ''
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'Nome/Razão Social'
                      },
                      {
                        colSpan: 7,
                        text: recipientData?.name
                      }
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'CEP'
                      },
                      {
                        colSpan: 1,
                        text: recipientData?.address?.zipPostalCode
                      },
                      {
                        colSpan: 1,
                        text: 'Endereço'
                      },
                      {
                        colSpan: 3,
                        text: recipientData?.address?.streetAddress
                      },
                      '',
                      '',
                      {
                        colSpan: 1,
                        text: 'Número'
                      },
                      {
                        colSpan: 1,
                        text: recipientData?.address?.streetAddressNumber
                      }
                    ],
                    [
                      {
                        colSpan: 1,
                        text: 'Complemento'
                      },
                      {
                        colSpan: 1,
                        text: recipientData?.address?.additionalInformation
                      },
                      {
                        colSpan: 1,
                        text: 'Bairro'
                      },
                      {
                        colSpan: 1,
                        text: recipientData?.address?.suburb
                      },
                      {
                        colSpan: 1,
                        text: 'Cidade'
                      },
                      {
                        colSpan: 1,
                        text: recipientData?.address?.city
                      },
                      {
                        colSpan: 1,
                        text: 'Estado'
                      },
                      {
                        colSpan: 1,
                        text: recipientData?.address?.state
                      }
                    ]
                  ]
                }
              }
            ],
            [
              {
                margin: [0, 10, 0, 0],
                table: {
                  widths: [120, 70, 40, 74, 60, '*'],
                  body: commodityBody
                }
              }
            ],
            [
              {
                margin: [0, 10, 0, 0],
                table: {
                  widths: [505],
                  body: [
                    [{ text: 'Local e Data Declaração' }],
                    [
                      {
                        margin: [0, 10, 0, 10],
                        text: `${locale}, ${dateParsed}`
                      }
                    ],
                    [
                      {
                        table: {
                          widths: [300, 185],
                          body: [
                            ['Nome e Documento', 'Assinatura'],
                            [
                              {
                                border: [true, true, true, false],
                                text: ' '
                              },
                              {
                                border: [true, true, true, false],
                                text: ' '
                              }
                            ],
                            [
                              {
                                border: [true, false, true, false],
                                text: ' '
                              },
                              {
                                border: [true, false, true, false],
                                text: ' '
                              }
                            ],
                            [
                              {
                                border: [true, false, true, true],
                                text: ' '
                              },
                              {
                                border: [true, false, true, true],
                                text: ' '
                              }
                            ]
                          ]
                        }
                      }
                    ]
                  ]
                }
              }
            ]
          ]
        }
      }
    ]
  };
};
